const SupplierBaseInfoView = ({ supplier }) => {
  return (
    <div className="card">
      <h5>Contact</h5>
      <div className="-mx-2 whitespace-nowrap mt-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Contact Person: </label>
              </td>
              <td className="w-full">{supplier.contactPerson}</td>
            </tr>
            <tr>
              <td>
                <label>Contact Address: </label>
              </td>
              <td className="w-full whitespace-pre-wrap">
                {supplier.contactAddress}
              </td>
            </tr>
            <tr>
              <td>
                <label>Email: </label>
              </td>
              <td className="w-full">{supplier.user?.email}</td>
            </tr>
            <tr>
              <td>
                <label>Phone: </label>
              </td>
              <td className="w-full">{supplier.phone}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupplierBaseInfoView;
